document.addEventListener('DOMContentLoaded', function () {
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach((question) => {
    question.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all
      faqQuestions.forEach((q) => {
        q.setAttribute('aria-expanded', 'false');
        q.nextElementSibling.style.display = 'none';
      });

      // Open clicked one if it was closed
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        this.nextElementSibling.style.display = 'block';
      }
    });
  });
});
